import { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import appInsights from "./applicationInsights";
import Login from "./screens/Login";
import { store } from "./redux/store";
import { Provider } from "react-redux";
import MobileLayout from "./layouts/mobileLayout";
import IaDashboard from "./screens/IaDashboard";
import IaDashboardSharma from "./screens/IaDashboardSharma";
import ArchitecturePage from "./web/pages/technical/architecturePage";
import RobustnessPage from "./web/pages/technical/robustnessPage";
import MultiAssetPage from "./web/pages/technical/multiAssetPage";
import Home from "./web/pages/webapp";
import ProtectedRoute from "./components/ProtectedRoute";
import ClientRedirect from "./components/ClientRedirect";
import ClientCasePage from "./web/clientCases/ClientCasePage";
import BuildInfoPage from "./web/pages/buildInfoPage";

export default function App() {
  useEffect(() => {
    appInsights.trackEvent(
      { name: "WebsiteVisited" },
      {
        url: window.location.href,
        path: window.location.pathname,
        hostname: window.location.hostname,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        language: navigator.language
      }
    );
  }, []);

  return (
    <MobileLayout maxWidth={500} frame>
      <Provider store={store}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/Login" element={<Login />} />
          <Route
            path="/IaDashboard"
            element={
              <ProtectedRoute>
                <IaDashboard />
              </ProtectedRoute>
            }
          />

          <Route
            path="/app-sharma/Login"
            element={
              <Login variant="sharma" dashboardPath="/app-sharma/IaDashboard" />
            }
          />
          <Route
            path="/app-sharma/IaDashboard"
            element={
              <ProtectedRoute loginPath="/app-sharma/Login">
                <IaDashboardSharma />
              </ProtectedRoute>
            }
          />

          <Route
            path="/architecture-of-platform"
            element={<ArchitecturePage />}
          />
          <Route
            path="/robustness-of-ryse-methodology"
            element={<RobustnessPage />}
          />
          <Route
            path="/multi-asset-class-support"
            element={<MultiAssetPage />}
          />
          <Route path="/build-info" element={<BuildInfoPage />} />

          {/* Client Case Story Pages */}
          <Route path="/case/:caseId" element={<ClientCasePage />} />

          {/* Typical Client Implementations */}
          <Route
            path="/pension"
            element={
              <ClientRedirect targetUrl="http://ryseagent.com/RyseServerProject_PensionFd/index.html" />
            }
          />
          <Route
            path="/African-Soc-Sec_Fund"
            element={
              <ClientRedirect targetUrl="http://ryseagent.com/NSSF/index.html" />
            }
          />
          <Route
            path="/family-office"
            element={
              <ClientRedirect targetUrl="http://ryseagent.com/RyseServerProjectFLyOffice/index.html" />
            }
          />
          <Route
            path="/private-equity"
            element={
              <ClientRedirect targetUrl="http://ryseagent.com/RyseServerProj_PEFd/index.html" />
            }
          />
          <Route
            path="/crypto"
            element={
              <ClientRedirect targetUrl="http://ryseagent.com/RyseServerProj_CryptoFd/index.html" />
            }
          />
          <Route
            path="/individual"
            element={
              <ClientRedirect targetUrl="http://ryseagent.com/RyseServerProj_Individual/index.html" />
            }
          />
          <Route
            path="/Middle-Income"
            element={
              <ClientRedirect targetUrl="http://ryseagent.com/RyseServerProject_Personal/index.html" />
            }
          />
        </Routes>
      </Provider>
    </MobileLayout>
  );
}
